export const COUNTRIES = [
  { value: "afghanistan", label: "Afghanistan AFG" },
  { value: "albania", label: "Albania ALB" },
  { value: "algeria", label: "Algeria DZA" },
  { value: "american-samoa", label: "American Samoa ASM" },
  { value: "andorra", label: "Andorra AND" },
  { value: "angola", label: "Angola AGO" },
  { value: "anguilla", label: "Anguilla AIA" },
  { value: "antarctica", label: "Antarctica ATA" },
  { value: "antigua-and-barbuda", label: "Antigua and Barbuda ATG" },
  { value: "argentina", label: "Argentina ARG" },
  { value: "armenia", label: "Armenia ARM" },
  { value: "aruba", label: "Aruba ABW" },
  { value: "australia", label: "Australia AUS" },
  { value: "austria", label: "Austria AUT" },
  { value: "azerbaijan", label: "Azerbaijan AZE" },
  { value: "bahamas", label: "Bahamas BHS" },
  { value: "bahrain", label: "Bahrain BHR" },
  { value: "bangladesh", label: "Bangladesh BGD" },
  { value: "barbados", label: "Barbados BRB" },
  { value: "belarus", label: "Belarus BLR" },
  { value: "belgium", label: "Belgium BEL" },
  { value: "belize", label: "Belize BLZ" },
  { value: "benin", label: "Benin BEN" },
  { value: "bermuda", label: "Bermuda BMU" },
  { value: "bhutan", label: "Bhutan BTN" },
  { value: "bolivia", label: "Bolivia BOL" },
  { value: "bonaire", label: "Bonaire BES" },
  { value: "bosnia-and-herzegovina", label: "Bosnia and Herzegovina BIH" },
  { value: "botswana", label: "Botswana BWA" },
  { value: "bouvet-island", label: "Bouvet Island BVT" },
  { value: "brazil", label: "Brazil BRA" },
  {
    value: "british-indian-ocean-territory",
    label: "British Indian Ocean Territory IOT",
  },
  { value: "brunei", label: "Brunei BRN" },
  { value: "bulgaria", label: "Bulgaria BGR" },
  { value: "burkina-faso", label: "Burkina Faso BFA" },
  { value: "burundi", label: "Burundi BDI" },
  { value: "cabo-verde", label: "Cabo Verde CPV" },
  { value: "cambodia", label: "Cambodia KHM" },
  { value: "cameroon", label: "Cameroon CMR" },
  { value: "canada", label: "Canada CAN" },
  { value: "cayman-islands", label: "Cayman Islands CYM" },
  { value: "central-african-republic", label: "Central African Republic CAF" },
  { value: "chad", label: "Chad TCD" },
  { value: "chile", label: "Chile CHL" },
  { value: "china", label: "China CHN" },
  { value: "christmas-island", label: "Christmas Island CXR" },
  { value: "cocos-keeling-islands", label: "Cocos (Keeling) Islands CCK" },
  { value: "colombia", label: "Colombia COL" },
  { value: "comoros", label: "Comoros COM" },
  { value: "congo", label: "Congo COG" },
  { value: "cook-islands", label: "Cook Islands COK" },
  { value: "costa-rica", label: "Costa Rica CRI" },
  { value: "croatia", label: "Croatia HRV" },
  { value: "cuba", label: "Cuba CUB" },
  { value: "curacao", label: "Curaçao CUW" },
  { value: "cyprus", label: "Cyprus CYP" },
  { value: "czech-republic", label: "Czech Republic CZE" },
  {
    value: "democratic-republic-of-the-congo",
    label: "Democratic Republic of the Congo COD",
  },
  { value: "denmark", label: "Denmark DNK" },
  { value: "djibouti", label: "Djibouti DJI" },
  { value: "dominica", label: "Dominica DMA" },
  { value: "dominican-republic", label: "Dominican Republic DOM" },
  { value: "east-timor", label: "East Timor TLS" },
  { value: "ecuador", label: "Ecuador ECU" },
  { value: "egypt", label: "Egypt EGY" },
  { value: "el-salvador", label: "El Salvador SLV" },
  { value: "equatorial-guinea", label: "Equatorial Guinea GNQ" },
  { value: "eritrea", label: "Eritrea ERI" },
  { value: "estonia", label: "Estonia EST" },
  { value: "eswatini", label: "Eswatini SWZ" },
  { value: "ethiopia", label: "Ethiopia ETH" },
  { value: "falkland-islands", label: "Falkland Islands FLK" },
  { value: "faroe-islands", label: "Faroe Islands FRO" },
  { value: "fiji", label: "Fiji FJI" },
  { value: "finland", label: "Finland FIN" },
  { value: "france", label: "France FRA" },
  { value: "france-coast", label: "France coast FRA" }, // Special case for multiple regions
  { value: "gabon", label: "Gabon GAB" },
  { value: "gambia", label: "Gambia GMB" },
  { value: "georgia", label: "Georgia GEO" },
  { value: "germany", label: "Germany DEU" },
  { value: "ghana", label: "Ghana GHA" },
  { value: "gibraltar", label: "Gibraltar GIB" },
  { value: "greece", label: "Greece GRC" },
  { value: "greenland", label: "Greenland GRL" },
  { value: "grenada", label: "Grenada GRD" },
  { value: "guadeloupe", label: "Guadeloupe GLP" },
  { value: "guam", label: "Guam GUM" },
  { value: "guatemala", label: "Guatemala GTM" },
  { value: "guernsey", label: "Guernsey GGY" },
  { value: "guinea", label: "Guinea GIN" },
  { value: "guinea-bissau", label: "Guinea-Bissau GNB" },
  { value: "guyana", label: "Guyana GUY" },
  { value: "haiti", label: "Haiti HTI" },
  { value: "honduras", label: "Honduras HND" },
  { value: "hong-kong", label: "Hong Kong HKG" },
  { value: "hungary", label: "Hungary HUN" },
  { value: "iceland", label: "Iceland ISL" },
  { value: "india", label: "India IND" },
  { value: "indonesia", label: "Indonesia IDN" },
  { value: "iran", label: "Iran IRN" },
  { value: "iraq", label: "Iraq IRQ" },
  { value: "ireland", label: "Ireland IRL" },
  { value: "isle-of-man", label: "Isle of Man IMN" },
  { value: "israel", label: "Israel ISR" },
  { value: "italy", label: "Italy ITA" },
  { value: "ivory-coast", label: "Ivory Coast (Côte d'Ivoire) CIV" },
  { value: "jamaica", label: "Jamaica JAM" },
  { value: "japan", label: "Japan JPN" },
  { value: "jersey", label: "Jersey JEY" },
  { value: "jordan", label: "Jordan JOR" },
  { value: "kazakhstan", label: "Kazakhstan KAZ" },
  { value: "kenya", label: "Kenya KEN" },
  { value: "kiribati", label: "Kiribati KIR" },
  { value: "north-korea", label: "North Korea PRK" },
  { value: "south-korea", label: "South Korea KOR" },
  { value: "kuwait", label: "Kuwait KWT" },
  { value: "kyrgyzstan", label: "Kyrgyzstan KGZ" },
  { value: "laos", label: "Lao People's Democratic Republic LAO" },
  { value: "latvia", label: "Latvia LVA" },
  { value: "lebanon", label: "Lebanon LBN" },
  { value: "lesotho", label: "Lesotho LSO" },
  { value: "liberia", label: "Liberia LBR" },
  { value: "libya", label: "Libya LBY" },
  { value: "liechtenstein", label: "Liechtenstein LIE" },
  { value: "lithuania", label: "Lithuania LTU" },
  { value: "luxembourg", label: "Luxembourg LUX" },
  { value: "macao", label: "Macao MAC" },
  { value: "madagascar", label: "Madagascar MDG" },
  { value: "malawi", label: "Malawi MWI" },
  { value: "malaysia", label: "Malaysia MYS" },
  { value: "maldives", label: "Maldives MDV" },
  { value: "mali", label: "Mali MLI" },
  { value: "malta", label: "Malta MLT" },
  { value: "marshall-islands", label: "Marshall Islands MHL" },
  { value: "martinique", label: "Martinique MTQ" },
  { value: "mauritania", label: "Mauritania MRT" },
  { value: "mauritius", label: "Mauritius MUS" },
  { value: "mayotte", label: "Mayotte MYT" },
  { value: "mexico", label: "Mexico MEX" },
  { value: "micronesia", label: "Micronesia FSM" },
  { value: "moldova", label: "Moldova MDA" },
  { value: "monaco", label: "Monaco MCO" },
  { value: "mongolia", label: "Mongolia MNG" },
  { value: "montenegro", label: "Montenegro MNE" },
  { value: "montserrat", label: "Montserrat MSR" },
  { value: "morocco", label: "Morocco MAR" },
  { value: "mozambique", label: "Mozambique MOZ" },
  { value: "myanmar", label: "Myanmar MMR" },
  { value: "namibia", label: "Namibia NAM" },
  { value: "nauru", label: "Nauru NRU" },
  { value: "nepal", label: "Nepal NPL" },
  { value: "netherlands", label: "Netherlands NLD" },
  { value: "new-caledonia", label: "New Caledonia NCL" },
  { value: "new-zealand", label: "New Zealand NZL" },
  { value: "nicaragua", label: "Nicaragua NIC" },
  { value: "niger", label: "Niger NER" },
  { value: "nigeria", label: "Nigeria NGA" },
  { value: "niue", label: "Niue NIU" },
  { value: "norfolk-island", label: "Norfolk Island NFK" },
  { value: "north-macedonia", label: "North Macedonia MKD" },
  { value: "northern-mariana-islands", label: "Northern Mariana Islands MNP" },
  { value: "norway", label: "Norway NOR" },
  { value: "oman", label: "Oman OMN" },
  { value: "pakistan", label: "Pakistan PAK" },
  { value: "palau", label: "Palau PLW" },
  { value: "palestine", label: "Palestine PSE" },
  { value: "panama", label: "Panama PAN" },
  { value: "papua-new-guinea", label: "Papua New Guinea PNG" },
  { value: "paraguay", label: "Paraguay PRY" },
  { value: "peru", label: "Peru PER" },
  { value: "philippines", label: "Philippines PHL" },
  { value: "pitcairn", label: "Pitcairn PCN" },
  { value: "poland", label: "Poland POL" },
  { value: "portugal", label: "Portugal PRT" },
  { value: "puerto-rico", label: "Puerto Rico PRI" },
  { value: "qatar", label: "Qatar QAT" },
  { value: "republic-of-the-congo", label: "Republic of the Congo COG" },
  { value: "romania", label: "Romania ROU" },
  { value: "russia", label: "Russia RUS" },
  { value: "rwanda", label: "Rwanda RWA" },
  { value: "saint-barthelemy", label: "Saint Barthelemy BLM" },
  { value: "saint-helena", label: "Saint Helena SHN" },
  { value: "saint-kitts-and-nevis", label: "Saint Kitts and Nevis KNA" },
  { value: "saint-lucia", label: "Saint Lucia LCA" },
  { value: "saint-martin", label: "Saint Martin MAF" },
  {
    value: "saint-pierre-and-miquelon",
    label: "Saint Pierre and Miquelon SPM",
  },
  {
    value: "saint-vincent-and-the-grenadines",
    label: "Saint Vincent and the Grenadines VCT",
  },
  { value: "samoa", label: "Samoa WSM" },
  { value: "san-marino", label: "San Marino SMR" },
  { value: "sao-tome-and-principe", label: "Sao Tome and Principe STP" },
  { value: "saudi-arabia", label: "Saudi Arabia SAU" },
  { value: "senegal", label: "Senegal SEN" },
  { value: "serbia", label: "Serbia SRB" },
  { value: "seychelles", label: "Seychelles SYC" },
  { value: "sierra-leone", label: "Sierra Leone SLE" },
  { value: "singapore", label: "Singapore SGP" },
  { value: "sint-maarten", label: "Sint Maarten SXM" },
  { value: "slovakia", label: "Slovakia SVK" },
  { value: "slovenia", label: "Slovenia SVN" },
  { value: "solomon-islands", label: "Solomon Islands SLB" },
  { value: "somalia", label: "Somalia SOM" },
  { value: "south-africa", label: "South Africa ZAF" },
  {
    value: "south-georgia-and-the-south-sandwich-islands",
    label: "South Georgia and the South Sandwich Islands SGS",
  },
  { value: "south-sudan", label: "South Sudan SSD" },
  { value: "spain", label: "Spain ESP" },
  { value: "sri-lanka", label: "Sri Lanka LKA" },
  { value: "sudan", label: "Sudan SDN" },
  { value: "suriname", label: "Suriname SUR" },
  { value: "svalbard-and-jan-mayen", label: "Svalbard and Jan Mayen SJM" },
  { value: "sweden", label: "Sweden SWE" },
  { value: "switzerland", label: "Switzerland CHE" },
  { value: "syria", label: "Syria SYR" },
  { value: "taiwan", label: "Taiwan TWN" },
  { value: "tajikistan", label: "Tajikistan TJK" },
  { value: "tanzania", label: "Tanzania TZA" },
  { value: "thailand", label: "Thailand THA" },
  { value: "timor-leste", label: "Timor-Leste TLS" },
  { value: "togo", label: "Togo TGO" },
  { value: "tokelau", label: "Tokelau TKL" },
  { value: "tonga", label: "Tonga TON" },
  { value: "trinidad-and-tobago", label: "Trinidad and Tobago TTO" },
  { value: "tunisia", label: "Tunisia TUN" },
  { value: "turkey", label: "Turkey TUR" },
  { value: "turkmenistan", label: "Turkmenistan TKM" },
  { value: "turks-and-caicos-islands", label: "Turks and Caicos Islands TCA" },
  { value: "tuvalu", label: "Tuvalu TUV" },
  { value: "uganda", label: "Uganda UGA" },
  { value: "ukraine", label: "Ukraine UKR" },
  { value: "united-arab-emirates", label: "United Arab Emirates ARE" },
  { value: "united-kingdom", label: "United Kingdom GBR" },
  { value: "united-states", label: "United States USA" },
  {
    value: "united-states-minor-outlying-islands",
    label: "United States Minor Outlying Islands UMI",
  },
  { value: "uruguay", label: "Uruguay URY" },
  { value: "uzbekistan", label: "Uzbekistan UZB" },
  { value: "vanuatu", label: "Vanuatu VUT" },
  { value: "vatican-city", label: "Vatican City VAT" },
  { value: "venezuela", label: "Venezuela VEN" },
  { value: "vietnam", label: "Vietnam VNM" },
  { value: "virgin-islands", label: "Virgin Islands VIR" },
  { value: "wallis-and-futuna", label: "Wallis and Futuna WLF" },
  { value: "western-sahara", label: "Western Sahara ESH" },
  { value: "yemen", label: "Yemen YEM" },
  { value: "zambia", label: "Zambia ZMB" },
  { value: "zimbabwe", label: "Zimbabwe ZWE" },
];
export const CASINO_CATEGORIES = [
  {
    value: "Online Casino",
    label: "Online Casino",
  },
];

export const CASINO_OWNERS = [
  { value: "SG International N.V", label: "SG International N.V" },
  {
    value: "Universe Entertainment Services Malta Limited",
    label: "Universe Entertainment Services Malta Limited",
  },
  { value: "10Bet LTD Casinos", label: "10Bet LTD Casinos" },
  { value: "7StartsPartners", label: "7StartsPartners" },
  { value: "888 UK Limited", label: "888 UK Limited" },
  { value: "Altacore N.V.", label: "Altacore N.V." },
  { value: "Araxio Development N.V.", label: "Araxio Development N.V." },
  { value: "Arbath Solutions OU", label: "Arbath Solutions OU" },
  {
    value: "Aspire Global Technologies Limited",
    label: "Aspire Global Technologies Limited",
  },
  { value: "Avento MT Limited", label: "Avento MT Limited" },
  { value: "Avento N.V.", label: "Avento N.V." },
  { value: "Bayton Limited", label: "Bayton Limited" },
  { value: "Bayview Technologies Inc.", label: "Bayview Technologies Inc." },
  { value: "Bestbet Limited", label: "Bestbet Limited" },
  {
    value: "bet-at-home.com Internet Limited Casinos",
    label: "bet-at-home.com Internet Limited Casinos",
  },
  { value: "Betdrive N.V. Casinos", label: "Betdrive N.V. Casinos" },
  {
    value: "Bethard Group Limited Casinos",
    label: "Bethard Group Limited Casinos",
  },
  { value: "BetIt Operations Ltd", label: "BetIt Operations Ltd" },
  { value: "BetOnline", label: "BetOnline" },
  { value: "Betpoint Group Limited", label: "Betpoint Group Limited" },
  { value: "Betway Limited", label: "Betway Limited" },
  { value: "Blackstone Systems Limited", label: "Blackstone Systems Limited" },
  { value: "Blue Media N.V. Casinos", label: "Blue Media N.V. Casinos" },
  { value: "BlueBet Pty Ltd", label: "BlueBet Pty Ltd" },
  { value: "BML Group Ltd", label: "BML Group Ltd" },
  { value: "Bonnal Ltd Casinos", label: "Bonnal Ltd Casinos" },
  { value: "Boomerang Goup", label: "Boomerang Goup" },
  { value: "Borse Platform B.V.", label: "Borse Platform B.V." },
  { value: "Carletta Limited", label: "Carletta Limited" },
  { value: "Caspo Ltd. Casinos", label: "Caspo Ltd. Casinos" },
  { value: "Casumo Services Limited", label: "Casumo Services Limited" },
  { value: "Co-Gaming Limited", label: "Co-Gaming Limited" },
  {
    value: "Codere Online Operator Limited",
    label: "Codere Online Operator Limited",
  },
  { value: "Condor Gaming", label: "Condor Gaming" },
  {
    value: "Continental Solutions BV Limited",
    label: "Continental Solutions BV Limited",
  },
  { value: "Cyberplay Management Ltd.", label: "Cyberplay Management Ltd." },
  { value: "DAMA N.V", label: "DAMA N.V" },
  { value: "Dama N.V. Curacao", label: "Dama N.V. Curacao" },
  { value: "Deckmedia N.V.", label: "Deckmedia N.V." },
  { value: "Direx N.V", label: "Direx N.V" },
  { value: "Ellmount Gaming Ltd", label: "Ellmount Gaming Ltd" },
  {
    value: "Entertainment Software Group N.V.",
    label: "Entertainment Software Group N.V.",
  },
  { value: "Equinox Dynamic N.V.", label: "Equinox Dynamic N.V." },
  { value: "EveryMatrix Ltd", label: "EveryMatrix Ltd" },
  { value: "FairGame G.P. N.V.", label: "FairGame G.P. N.V." },
  { value: "Fairload Ltd Casinos", label: "Fairload Ltd Casinos" },
  {
    value: "Genesis Global Limited Casinos",
    label: "Genesis Global Limited Casinos",
  },
  { value: "Glizzard Ltd.", label: "Glizzard Ltd." },
  { value: "Greenvest Betting Ltd.", label: "Greenvest Betting Ltd." },
  { value: "GVC Holdings PLC", label: "GVC Holdings PLC" },
  { value: "HighWeb Ventures N.V.", label: "HighWeb Ventures N.V." },
  { value: "Hollycorn N.V.", label: "Hollycorn N.V." },
  { value: "IGamical Group Ltd.", label: "IGamical Group Ltd." },
  { value: "Imion Ltd Casinos", label: "Imion Ltd Casinos" },
  { value: "Jupiter Gaming", label: "Jupiter Gaming" },
  { value: "L&amp;L Europe Ltd", label: "L&amp;L Europe Ltd" },
  { value: "LeoVegas Gaming Limited", label: "LeoVegas Gaming Limited" },
  { value: "Lynton Limited Casino", label: "Lynton Limited Casino" },
  { value: "Mansion Group Casinos", label: "Mansion Group Casinos" },
  { value: "Marikit Holdings Ltd", label: "Marikit Holdings Ltd" },
  { value: "Marketplay LTD", label: "Marketplay LTD" },
  {
    value: "mBet Solutions N.V. Casinos",
    label: "mBet Solutions N.V. Casinos",
  },
  { value: "Megapari Ltd.", label: "Megapari Ltd." },
  { value: "Mirage Corporation N.V.", label: "Mirage Corporation N.V." },
  {
    value: "Mobile Technology Marketing Limited (MTM Corp)",
    label: "Mobile Technology Marketing Limited (MTM Corp)",
  },
  { value: "Morris Mohawk Gaming Group", label: "Morris Mohawk Gaming Group" },
  { value: "Mountberg B.V.", label: "Mountberg B.V." },
  { value: "MT SecureTrade Limited", label: "MT SecureTrade Limited" },
  { value: "N1 Interactive Ltd", label: "N1 Interactive Ltd" },
  { value: "NEG Group Limited", label: "NEG Group Limited" },
  { value: "OneClick Ltd", label: "OneClick Ltd" },
  { value: "Oring Ltd", label: "Oring Ltd" },
  { value: "Pelican Entertainment Ltd.", label: "Pelican Entertainment Ltd." },
  { value: "PlayUp Interactive Pty Ltd", label: "PlayUp Interactive Pty Ltd" },
  { value: "Pomadorro N.V.", label: "Pomadorro N.V." },
  {
    value: "Pro Xenon Mediathek Limited",
    label: "Pro Xenon Mediathek Limited",
  },
  { value: "Probe Investments Limited", label: "Probe Investments Limited" },
  { value: "Rabidi N.V.", label: "Rabidi N.V." },
  { value: "Rainmen Group N.V.", label: "Rainmen Group N.V." },
  { value: "Reinvent N.V.", label: "Reinvent N.V." },
  {
    value: "Rhinoceros Operations Limited",
    label: "Rhinoceros Operations Limited",
  },
  { value: "Rivieraplay", label: "Rivieraplay" },
  { value: "Romix Limited", label: "Romix Limited" },
  { value: "Royal Panda Limited", label: "Royal Panda Limited" },
  { value: "SBGC S.R.L.", label: "SBGC S.R.L." },
  { value: "SkillOnNet Limited", label: "SkillOnNet Limited" },
  { value: "SSC ENTERTAINMENT N.V.", label: "SSC ENTERTAINMENT N.V." },
  { value: "Superior Share", label: "Superior Share" },
  { value: "Superior VIP Group", label: "Superior VIP Group" },
  {
    value: "TechSolutions Group Limited",
    label: "TechSolutions Group Limited",
  },
  { value: "TH Gambling N.V.", label: "TH Gambling N.V." },
  { value: "ThinkQuick Ltd", label: "ThinkQuick Ltd" },
  { value: "Tipbet Limited", label: "Tipbet Limited" },
  { value: "TTM BV", label: "TTM BV" },
  { value: "Tutkia Limited", label: "Tutkia Limited" },
  {
    value: "WHG (International) Limited",
    label: "WHG (International) Limited",
  },
  { value: "White Hat Gaming LTD", label: "White Hat Gaming LTD" },
];

export const CASINO_TESTING_AGENCIES = [
  { value: "BMM Testlabs", label: "BMM Testlabs" },
  { value: "eCOGRA", label: "eCOGRA" },
  { value: "Gaming Labs International", label: "Gaming Labs International" },
  { value: "Gaming Limited", label: "Gaming Limited" },
  {
    value: "Independent Betting Adjudication Service (IBAS)",
    label: "Independent Betting Adjudication Service (IBAS)",
  },
  { value: "iTech Labs", label: "iTech Labs" },
  { value: "NMi Metrology", label: "NMi Metrology" },
  { value: "PwC Malta", label: "PwC Malta" },
  { value: "QA", label: "QA" },
  { value: "SoftSwiss", label: "SoftSwiss" },
  {
    value: "Technical System Testing (TST)",
    label: "Technical System Testing (TST)",
  },
];

export const CURRENCIES = [
  { value: "Albanian Lek", label: "Albanian Lek ALL" },
  { value: "Angolan Kwanza", label: "Angolan Kwanza AOA" },
  { value: "Argentine Peso", label: "Argentine Peso ARS" },
  { value: "Armenian Dram", label: "Armenian Dram AMD" },
  { value: "Australian Dollar", label: "Australian Dollar AUD" },
  { value: "Azerbaijani Manat", label: "Azerbaijani Manat AZN" },
  { value: "Bahraini Dinar", label: "Bahraini Dinar BHD" },
  { value: "Bangladeshi Taka", label: "Bangladeshi Taka BDT" },
  { value: "Belarusian Ruble", label: "Belarusian Ruble BYN" },
  { value: "BitCoin", label: "BitCoin BTC" },
  { value: "Bitcoin Cash", label: "Bitcoin Cash BCH" },
  { value: "BitShares", label: "BitShares BTS" },
  { value: "Bolivian Boliviano", label: "Bolivian Boliviano BOB" },
  {
    value: "Bosnia and Herzegovina Convertible Mark",
    label: "Bosnia and Herzegovina Convertible Mark BAM",
  },
  { value: "Botswana Pula", label: "Botswana Pula BWP" },
  { value: "Brazilian Reals", label: "Brazilian Reals BRL" },
  { value: "British Pound Sterling", label: "British Pound Sterling GBP" },
  { value: "Bulgarian Leva", label: "Bulgarian Leva BGN" },
  { value: "Burmese Kyat", label: "Burmese Kyat MMK" },
  { value: "Burundian Franc", label: "Burundian Franc BIF" },
  { value: "Bytecoin", label: "Bytecoin BCN" },
  { value: "Canadian Dollar", label: "Canadian Dollar CAD" },
  { value: "Chilean Peso", label: "Chilean Peso CLP" },
  { value: "Chinese Yuan", label: "Chinese Yuan CNY" },
  { value: "Colombian Peso", label: "Colombian Peso COP" },
  { value: "Congolese Franc", label: "Congolese Franc CDF" },
  { value: "Costa Rican Colon", label: "Costa Rican Colon CRC" },
  { value: "Croatian Kuna", label: "Croatian Kuna HRK" },
  { value: "Czech Koruny", label: "Czech Koruny CZK" },
  { value: "Czech Republic Koruna", label: "Czech Republic Koruna CZK" },
  { value: "Danish Kronor", label: "Danish Kronor DKK" },
  { value: "Denmark Kroner", label: "Denmark Kroner DKK" },
  { value: "Dogecoin", label: "Dogecoin DOGE" },
  { value: "Egyptian Pound", label: "Egyptian Pound EGP" },
  { value: "Eritrean Nakfa", label: "Eritrean Nakfa ERN" },
  { value: "Ethereum", label: "Ethereum ETH" },
  { value: "Euro", label: "Euro EUR" },
  { value: "FUN", label: "FUN FUN" },
  { value: "Georgian Lari", label: "Georgian Lari GEL" },
  { value: "Hong Kong Dollar", label: "Hong Kong Dollar HKD" },
  { value: "Hungarian Forint", label: "Hungarian Forint HUF" },
  { value: "Icelandic Króna", label: "Icelandic Króna ISK" },
  { value: "Indian Rupee", label: "Indian Rupee INR" },
  { value: "Indonesian Rupiah", label: "Indonesian Rupiah IDR" },
  { value: "Iranian Rial", label: "Iranian Rial IRR" },
  { value: "Iraqi Dinar", label: "Iraqi Dinar IQD" },
  { value: "Israeli New Shekel", label: "Israeli New Shekel ILS" },
  { value: "Jamaican Dollar", label: "Jamaican Dollar JMD" },
  { value: "Japanese Yen", label: "Japanese Yen JPY" },
  { value: "Kazakhstani Tenge", label: "Kazakhstani Tenge KZT" },
  { value: "Kuwaiti Dinar", label: "Kuwaiti Dinar KWD" },
  { value: "Latvian Lats", label: "Latvian Lats LVL" },
  { value: "Lesotho Loti", label: "Lesotho Loti LSL" },
  { value: "Liberian Dollar", label: "Liberian Dollar LRD" },
  { value: "Libyan Dinar", label: "Libyan Dinar LYD" },
  { value: "Litai", label: "Litai LTL" },
  { value: "Litecoin", label: "Litecoin LTC" },
  { value: "Lithuanian Litas", label: "Lithuanian Litas LTL" },
  { value: "Macedonian Denar", label: "Macedonian Denar MKD" },
  { value: "Malagasy Ariary", label: "Malagasy Ariary MGA" },
  { value: "Malaysian Ringgit", label: "Malaysian Ringgit MYR" },
  { value: "Mexican Peso", label: "Mexican Peso MXN" },
  { value: "Moldovan Leu", label: "Moldovan Leu MDL" },
  { value: "Moroccan Dirham", label: "Moroccan Dirham MAD" },
  { value: "Mozambican Metical", label: "Mozambican Metical MZN" },
  { value: "Namibian Dollar", label: "Namibian Dollar NAD" },
  { value: "New Taiwan Dollar", label: "New Taiwan Dollar TWD" },
  { value: "New Zealand Dollar", label: "New Zealand Dollar NZD" },
  { value: "Nigerian Nairas", label: "Nigerian Nairas NGN" },
  { value: "Norwegian Kroner", label: "Norwegian Kroner NOK" },
  { value: "Omani Rial", label: "Omani Rial OMR" },
  { value: "Pakistani Rupee", label: "Pakistani Rupee PKR" },
  { value: "Paraguayan Guaraní", label: "Paraguayan Guaraní PYG" },
  { value: "Peruvian Sol", label: "Peruvian Sol PEN" },
  { value: "Philippine Peso", label: "Philippine Peso PHP" },
  { value: "Polish Złoty", label: "Polish Złoty PLN" },
  { value: "Qatari Riyal", label: "Qatari Riyal QAR" },
  { value: "Ripple", label: "Ripple XRP" },
  { value: "Romanian Lei", label: "Romanian Lei RON" },
  { value: "Russian Rubles", label: "Russian Rubles RUB" },
  { value: "Saudi Riyal", label: "Saudi Riyal SAR" },
  { value: "Serbian Dinar", label: "Serbian Dinar RSD" },
  { value: "Singapore Dollar", label: "Singapore Dollar SGD" },
  { value: "South African Rand", label: "South African Rand ZAR" },
  { value: "South Korean Won", label: "South Korean Won KRW" },
  { value: "Sri Lankan Rupee", label: "Sri Lankan Rupee LKR" },
  { value: "Swedish Kronor", label: "Swedish Kronor SEK" },
  { value: "Swiss Franc", label: "Swiss Franc CHF" },
  { value: "Tajikistani Somoni", label: "Tajikistani Somoni TJS" },
  { value: "Tether USDT", label: "Tether USDT" },
  { value: "Thai Baht", label: "Thai Baht THB" },
  { value: "Tunisian Dinar", label: "Tunisian Dinar TND" },
  { value: "Turkish Lira", label: "Turkish Lira TRY" },
  { value: "Turkmenistan Manat", label: "Turkmenistan Manat TMT" },
  { value: "Ukrainian Hryvnia", label: "Ukrainian Hryvnia UAH" },
  {
    value: "United Arab Emirates Dirham",
    label: "United Arab Emirates Dirham AED",
  },
  { value: "Uruguayan Peso", label: "Uruguayan Peso UYU" },
  { value: "US Dollar", label: "US Dollar USD" },
  { value: "Uzbekistani Soʻm", label: "Uzbekistani Soʻm UZS" },
  { value: "Venezuelan Bolívar", label: "Venezuelan Bolívar VES" },
  { value: "Vietnamese Dong", label: "Vietnamese Dong VND" },
];

export const DEPOSIT_METHODS = [
  { value: "24nonstop", label: "24nonstop" },
  { value: "Abaqoos", label: "Abaqoos" },
  { value: "AGMO", label: "AGMO" },
  { value: "Airtel", label: "Airtel" },
  { value: "Aktia", label: "Aktia" },
  { value: "Alfa Click", label: "Alfa Click" },
  { value: "Alfa Pay", label: "Alfa Pay" },
  { value: "Alfa-Bank", label: "Alfa-Bank" },
  { value: "American Express", label: "American Express" },
  { value: "Amigo", label: "Amigo" },
  { value: "Amigo", label: "Amigo" },
  { value: "ApplePay", label: "ApplePay" },
  { value: "AsiaHawala", label: "AsiaHawala" },
  { value: "AstroPay Card", label: "AstroPay Card" },
  { value: "B-pay", label: "B-pay" },
  { value: "Baloto", label: "Baloto" },
  { value: "BancodeChili", label: "BancodeChili" },
  { value: "Bancontact/ Mister Cash", label: "Bancontact/ Mister Cash" },
  { value: "Bank Draft", label: "Bank Draft" },
  { value: "Bank Transfer", label: "Bank Transfer" },
  { value: "Bank Transfer Express", label: "Bank Transfer Express" },
  { value: "Bank Wire Transfer", label: "Bank Wire Transfer" },
  { value: "BankLink", label: "BankLink" },
  { value: "Beeline", label: "Beeline" },
  { value: "Binance Coin", label: "Binance Coin" },
  { value: "BitCoin", label: "BitCoin" },
  { value: "Bitcoin Cash", label: "Bitcoin Cash" },
  { value: "Boku", label: "Boku" },
  { value: "Boleto", label: "Boleto" },
  { value: "BPay", label: "BPay" },
  { value: "Bradesco", label: "Bradesco" },
  { value: "Cardano", label: "Cardano" },
  { value: "CartaSi", label: "CartaSi" },
  { value: "Carte Bancaire", label: "Carte Bancaire" },
  { value: "Carte Bleue", label: "Carte Bleue" },
  { value: "Cashenvoy", label: "Cashenvoy" },
  { value: "Cashlib", label: "Cashlib" },
  { value: "CashtoCode", label: "CashtoCode" },
  { value: "CBE", label: "CBE" },
  { value: "Cheque", label: "Cheque" },
  { value: "China Union Pay", label: "China Union Pay" },
  { value: "ClickandBuy", label: "ClickandBuy" },
  { value: "CoinsPaid", label: "CoinsPaid" },
  { value: "ComePay", label: "ComePay" },
  { value: "Credit and Debit Cards", label: "Credit and Debit Cards" },
  { value: "Cubits", label: "Cubits" },
  { value: "CuentaDigital", label: "CuentaDigital" },
  { value: "Dankort", label: "Dankort" },
  { value: "Danske Bank", label: "Danske Bank" },
  { value: "Dash", label: "Dash" },
  { value: "DineroMail", label: "DineroMail" },
  { value: "Diners Club International", label: "Diners Club International" },
  { value: "Direct Bank Transfer", label: "Direct Bank Transfer" },
  { value: "DiscoverBank", label: "DiscoverBank" },
  { value: "Dogecoin", label: "Dogecoin" },
  { value: "Dohone", label: "Dohone" },
  { value: "Dotpay", label: "Dotpay" },
  { value: "E-Wallets", label: "E-Wallets" },
  { value: "Easy EFT", label: "Easy EFT" },
  { value: "Easy Pay", label: "Easy Pay" },
  { value: "EazzyPay", label: "EazzyPay" },
  { value: "EcoCard", label: "EcoCard" },
  { value: "EcoPayz", label: "EcoPayz" },
  { value: "EcoVoucher", label: "EcoVoucher" },
  { value: "EgyptPayments", label: "EgyptPayments" },
  { value: "eKonto", label: "eKonto" },
  { value: "Elegro", label: "Elegro" },
  { value: "eLipa", label: "eLipa" },
  { value: "EnterCash", label: "EnterCash" },
  { value: "Entropay", label: "Entropay" },
  { value: "ePay.bg", label: "ePay.bg" },
  { value: "ePro Vouchers", label: "ePro Vouchers" },
  { value: "EPS", label: "EPS" },
  { value: "Ethereum", label: "Ethereum" },
  { value: "eTransfer", label: "eTransfer" },
  { value: "Euroset", label: "Euroset" },
  { value: "Euteller", label: "Euteller" },
  { value: "Evroset", label: "Evroset" },
  { value: "Ewire", label: "Ewire" },
  { value: "Express Pay Azerbaijan", label: "Express Pay Azerbaijan" },
  { value: "Express Union Cameroon", label: "Express Union Cameroon" },
  { value: "eZeeWallet", label: "eZeeWallet" },
  { value: "Ezi-Pay", label: "Ezi-Pay" },
  { value: "Fast Bank Transfer", label: "Fast Bank Transfer" },
  { value: "Flexipin", label: "Flexipin" },
  { value: "FUN", label: "FUN" },
  { value: "FundSend", label: "FundSend" },
  { value: "Gift Card", label: "Gift Card" },
  { value: "GiroPay", label: "GiroPay" },
  { value: "Gluepay", label: "Gluepay" },
  { value: "gocash88", label: "gocash88" },
  { value: "GoPlay", label: "GoPlay" },
  { value: "i-Banq", label: "i-Banq" },
  { value: "iBank", label: "iBank" },
  { value: "iDEAL", label: "iDEAL" },
  { value: "iDebit", label: "iDebit" },
  { value: "Infinity Economics", label: "Infinity Economics" },
  { value: "Inpay", label: "Inpay" },
  { value: "InstaDebit", label: "InstaDebit" },
  { value: "Instant Bank Transfer", label: "Instant Bank Transfer" },
  {
    value: "Instant Banking powered by Citadel",
    label: "Instant Banking powered by Citadel",
  },
  { value: "InstantTransfer", label: "InstantTransfer" },
  { value: "Interac e-Transfer", label: "Interac e-Transfer" },
  { value: "Interac Online", label: "Interac Online" },
  { value: "Interbank", label: "Interbank" },
  { value: "iWallet", label: "iWallet" },
  { value: "Jeton", label: "Jeton" },
  { value: "Jeton Wallet", label: "Jeton Wallet" },
  { value: "Kassa24", label: "Kassa24" },
  { value: "Klarna", label: "Klarna" },
  { value: "Kluwp", label: "Kluwp" },
  { value: "Kyivstar", label: "Kyivstar" },
  { value: "LAVA Pay", label: "LAVA Pay" },
  { value: "Libertis Mobicash", label: "Libertis Mobicash" },
  { value: "Litecoin", label: "Litecoin" },
  { value: "Lobanet", label: "Lobanet" },
  { value: "Lottomaticard", label: "Lottomaticard" },
  { value: "Luxon Pay", label: "Luxon Pay" },
  { value: "M-Birr", label: "M-Birr" },
  { value: "Maestro", label: "Maestro" },
  { value: "MasterCard", label: "MasterCard" },
  { value: "mBankomat", label: "mBankomat" },
  { value: "Megafon", label: "Megafon" },
  { value: "Megafone", label: "Megafone" },
  { value: "MiFinity", label: "MiFinity" },
  { value: "MobiCash", label: "MobiCash" },
  { value: "Mobile Commerce", label: "Mobile Commerce" },
  { value: "Monero", label: "Monero" },
  { value: "Moneta", label: "Moneta" },
  { value: "Moneta.ru", label: "Moneta.ru" },
  { value: "Money Global", label: "Money Global" },
  { value: "Money Orders", label: "Money Orders" },
  { value: "MoneySafe", label: "MoneySafe" },
  { value: "MTC", label: "MTC" },
  { value: "MTS", label: "MTS" },
  { value: "MuchBetter", label: "MuchBetter" },
  { value: "Multibanco", label: "Multibanco" },
  { value: "MyBux", label: "MyBux" },
  { value: "Neo Coin", label: "Neo Coin" },
  { value: "Neosurf", label: "Neosurf" },
  { value: "Neteller", label: "Neteller" },
  { value: "Nordea", label: "Nordea" },
  { value: "Online Bank Transfer", label: "Online Bank Transfer" },
  { value: "OP-Pohjola", label: "OP-Pohjola" },
  { value: "Pago Fácil", label: "Pago Fácil" },
  { value: "PagoEfectivo", label: "PagoEfectivo" },
  { value: "PassNGo", label: "PassNGo" },
  { value: "Pay4Fun", label: "Pay4Fun" },
  { value: "Paybox", label: "Paybox" },
  { value: "Paybyphone", label: "Paybyphone" },
  { value: "Paydunya", label: "Paydunya" },
  { value: "Payeer", label: "Payeer" },
  { value: "Paykasa", label: "Paykasa" },
  { value: "Paylevo", label: "Paylevo" },
  { value: "PayoStar", label: "PayoStar" },
  { value: "PayPal", label: "PayPal" },
  { value: "Paysafecard", label: "Paysafecard" },
  { value: "PaySec", label: "PaySec" },
  { value: "Payshop", label: "Payshop" },
  { value: "Paytrail", label: "Paytrail" },
  { value: "PayU", label: "PayU" },
  { value: "PayVision", label: "PayVision" },
  { value: "Pelepare", label: "Pelepare" },
  { value: "Perfect Money", label: "Perfect Money" },
  { value: "Person to Person", label: "Person to Person" },
  { value: "PingitPay", label: "PingitPay" },
  { value: "POLi", label: "POLi" },
  { value: "Portmanat", label: "Portmanat" },
  { value: "Postepay", label: "Postepay" },
  { value: "Prepaid Cards", label: "Prepaid Cards" },
  { value: "Profee", label: "Profee" },
  { value: "PromoCode", label: "PromoCode" },
  { value: "Promsvyazbank", label: "Promsvyazbank" },
  { value: "Przelewy24", label: "Przelewy24" },
  { value: "PugglePay", label: "PugglePay" },
  { value: "Puplepay", label: "Puplepay" },
  { value: "Purple Pay", label: "Purple Pay" },
  { value: "QIWI", label: "QIWI" },
  { value: "QQ-walet", label: "QQ-walet" },
  { value: "QuickPay", label: "QuickPay" },
  { value: "Rapid Transfer", label: "Rapid Transfer" },
  { value: "Rapipago", label: "Rapipago" },
  { value: "Ripple", label: "Ripple" },
  { value: "RunPay", label: "RunPay" },
  { value: "Russian Post", label: "Russian Post" },
  { value: "SafetyPay", label: "SafetyPay" },
  { value: "Santander", label: "Santander" },
  { value: "Sberbank Online", label: "Sberbank Online" },
  { value: "Scotiabank", label: "Scotiabank" },
  { value: "Sepa", label: "Sepa" },
  { value: "ServiPag", label: "ServiPag" },
  { value: "Siru Mobile", label: "Siru Mobile" },
  { value: "Skrill", label: "Skrill" },
  { value: "Skrill Rapid Transfer", label: "Skrill Rapid Transfer" },
  { value: "Skrill1-Tap", label: "Skrill1-Tap" },
  { value: "SnapScan", label: "SnapScan" },
  { value: "Sofort Banking", label: "Sofort Banking" },
  { value: "Sofortuberweisung", label: "Sofortuberweisung" },
  { value: "Solo Payment System", label: "Solo Payment System" },
  { value: "Speedcard", label: "Speedcard" },
  { value: "SporoPay", label: "SporoPay" },
  { value: "Steam", label: "Steam" },
  { value: "Sticpay", label: "Sticpay" },
  { value: "Suomen Verkkomaksut", label: "Suomen Verkkomaksut" },
  { value: "Svyaznoy", label: "Svyaznoy" },
  { value: "TDB Pay", label: "TDB Pay" },
  { value: "Tele2", label: "Tele2" },
  { value: "Teleingreso", label: "Teleingreso" },
  { value: "Telepay", label: "Telepay" },
  { value: "Tether (USDT)", label: "Tether (USDT)" },
  { value: "Ticket Premium", label: "Ticket Premium" },
  { value: "Todito Cash", label: "Todito Cash" },
  { value: "Trustly", label: "Trustly" },
  { value: "TrustPay", label: "TrustPay" },
  { value: "U.mob", label: "U.mob" },
  { value: "Ukash", label: "Ukash" },
  { value: "UnionPay", label: "UnionPay" },
  { value: "UPayCard", label: "UPayCard" },
  { value: "UseMyBank", label: "UseMyBank" },
  { value: "UseMyServices", label: "UseMyServices" },
  { value: "Uzcard", label: "Uzcard" },
  { value: "vcreditos", label: "vcreditos" },
  { value: "Venus Point", label: "Venus Point" },
  { value: "Virtual Card", label: "Virtual Card" },
  { value: "Virtual Card", label: "Virtual Card" },
  { value: "Visa", label: "Visa" },
  { value: "Visa Debit", label: "Visa Debit" },
  { value: "Visa Electron", label: "Visa Electron" },
  { value: "Vodacon Tanzania", label: "Vodacon Tanzania" },
  { value: "Voucher", label: "Voucher" },
  { value: "WebMoney", label: "WebMoney" },
  { value: "Webpay", label: "Webpay" },
  { value: "Wide UP", label: "Wide UP" },
  { value: "WireCard", label: "WireCard" },
  { value: "Yandex.Money", label: "Yandex.Money" },
  { value: "Zain Cash", label: "Zain Cash" },
  { value: "Zimpler", label: "Zimpler" },
  { value: "ZoomPayments", label: "ZoomPayments" },
  { value: "ZotaPay", label: "ZotaPay" },
];

export const PULLING_METHODS = [
  { value: "Cashlib", label: "Cashlib" },
  { value: "24nonstop", label: "24nonstop" },
  { value: "Airtel", label: "Airtel" },
  { value: "Aktia", label: "Aktia" },
  { value: "Alfa Click", label: "Alfa Click" },
  { value: "Alfa Pay", label: "Alfa Pay" },
  { value: "Alpha Click", label: "Alpha Click" },
  { value: "Altcoins", label: "Altcoins" },
  { value: "Amigo", label: "Amigo" },
  { value: "ApplePay", label: "ApplePay" },
  { value: "AsiaHawala", label: "AsiaHawala" },
  { value: "AstroPay Card", label: "AstroPay Card" },
  { value: "B-pay", label: "B-pay" },
  { value: "BancodeChili", label: "BancodeChili" },
  { value: "Bank Draft", label: "Bank Draft" },
  { value: "Bank Transfer", label: "Bank Transfer" },
  { value: "Bank Transfer Express", label: "Bank Transfer Express" },
  { value: "Bank Wire Transfer", label: "Bank Wire Transfer" },
  { value: "BankLink", label: "BankLink" },
  { value: "Beeline", label: "Beeline" },
  { value: "Binance Coin", label: "Binance Coin" },
  { value: "BitCoin", label: "BitCoin" },
  { value: "Bitcoin Cash", label: "Bitcoin Cash" },
  { value: "Boku", label: "Boku" },
  { value: "Boleto", label: "Boleto" },
  { value: "Bradesco", label: "Bradesco" },
  { value: "Cardano", label: "Cardano" },
  { value: "CartaSi", label: "CartaSi" },
  { value: "Cashenvoy", label: "Cashenvoy" },
  { value: "CashtoCode", label: "CashtoCode" },
  { value: "CBE", label: "CBE" },
  { value: "Cheque", label: "Cheque" },
  { value: "China Union Pay", label: "China Union Pay" },
  { value: "ClickandBuy", label: "ClickandBuy" },
  { value: "CoinsPaid", label: "CoinsPaid" },
  { value: "ComePay", label: "ComePay" },
  { value: "credEcardplus", label: "credEcardplus" },
  { value: "Credit and Debit Cards", label: "Credit and Debit Cards" },
  { value: "Cubits", label: "Cubits" },
  { value: "Dankort", label: "Dankort" },
  { value: "Dash", label: "Dash" },
  { value: "Diners Club International", label: "Diners Club International" },
  { value: "Direct Bank Transfer", label: "Direct Bank Transfer" },
  { value: "Dogecoin", label: "Dogecoin" },
  { value: "Dohone", label: "Dohone" },
  { value: "E-Wallets", label: "E-Wallets" },
  { value: "Easy EFT", label: "Easy EFT" },
  { value: "Easy Pay", label: "Easy Pay" },
  { value: "EazzyPay", label: "EazzyPay" },
  { value: "eChecks", label: "eChecks" },
  { value: "EcoCard", label: "EcoCard" },
  { value: "EcoPayz", label: "EcoPayz" },
  { value: "EcoVoucher", label: "EcoVoucher" },
  { value: "EgyptPayments", label: "EgyptPayments" },
  { value: "eKonto", label: "eKonto" },
  { value: "Elegro", label: "Elegro" },
  { value: "eLipa", label: "eLipa" },
  { value: "EnterCash", label: "EnterCash" },
  { value: "Entropay", label: "Entropay" },
  { value: "ePay.bg", label: "ePay.bg" },
  { value: "EPS", label: "EPS" },
  { value: "Ethereum", label: "Ethereum" },
  { value: "Euroset", label: "Euroset" },
  { value: "Euteller", label: "Euteller" },
  { value: "Express Pay Azerbaijan", label: "Express Pay Azerbaijan" },
  { value: "Express Union Cameroon", label: "Express Union Cameroon" },
  { value: "eZeeWallet", label: "eZeeWallet" },
  { value: "Ezi-Pay", label: "Ezi-Pay" },
  { value: "Fast Bank Transfer", label: "Fast Bank Transfer" },
  { value: "FUN", label: "FUN" },
  { value: "GiroPay", label: "GiroPay" },
  { value: "iBanq", label: "iBanq" },
  { value: "iDEAL", label: "iDEAL" },
  { value: "iDebit", label: "iDebit" },
  { value: "Infinity Economics", label: "Infinity Economics" },
  { value: "Inpay", label: "Inpay" },
  { value: "InstaDebit", label: "InstaDebit" },
  { value: "Instant Bank Transfer", label: "Instant Bank Transfer" },
  {
    value: "Instant Banking powered by Citadel",
    label: "Instant Banking powered by Citadel",
  },
  { value: "InstantTransfer", label: "InstantTransfer" },
  { value: "Interac e-Transfer", label: "Interac e-Transfer" },
  { value: "Interac Online", label: "Interac Online" },
  { value: "Interbank", label: "Interbank" },
  { value: "iWallet", label: "iWallet" },
  { value: "Jeton", label: "Jeton" },
  { value: "Jeton Wallet", label: "Jeton Wallet" },
  { value: "Kassa24", label: "Kassa24" },
  { value: "Klarna", label: "Klarna" },
  { value: "Kluwp", label: "Kluwp" },
  { value: "Kyivstar", label: "Kyivstar" },
  { value: "LAVA Pay", label: "LAVA Pay" },
  { value: "Libertis Mobicash", label: "Libertis Mobicash" },
  { value: "Litecoin", label: "Litecoin" },
  { value: "Lobanet", label: "Lobanet" },
  { value: "M-Birr", label: "M-Birr" },
  { value: "Maestro", label: "Maestro" },
  { value: "MasterCard", label: "MasterCard" },
  { value: "Megafon", label: "Megafon" },
  { value: "MiFinity", label: "MiFinity" },
  { value: "MobiCash", label: "MobiCash" },
  { value: "Mobile Commerce", label: "Mobile Commerce" },
  { value: "Monero", label: "Monero" },
  { value: "Moneta", label: "Moneta" },
  { value: "Moneta.ru", label: "Moneta.ru" },
  { value: "Money Global", label: "Money Global" },
  { value: "Money Orders", label: "Money Orders" },
  { value: "MoneySafe", label: "MoneySafe" },
  { value: "MTS", label: "MTS" },
  { value: "MuchBetter", label: "MuchBetter" },
  { value: "Multibanco", label: "Multibanco" },
  { value: "MyBux", label: "MyBux" },
  { value: "Neo Coin", label: "Neo Coin" },
  { value: "Neosurf", label: "Neosurf" },
  { value: "Neteller", label: "Neteller" },
  { value: "Nordea", label: "Nordea" },
  { value: "Online Bank Transfer", label: "Online Bank Transfer" },
  { value: "OP-Pohjola", label: "OP-Pohjola" },
  { value: "Pago Fácil", label: "Pago Fácil" },
  { value: "PassNGo", label: "PassNGo" },
  { value: "Pay4Fun", label: "Pay4Fun" },
  { value: "Paybox", label: "Paybox" },
  { value: "Paydunya", label: "Paydunya" },
  { value: "Payeer", label: "Payeer" },
  { value: "Paykasa", label: "Paykasa" },
  { value: "Paylevo", label: "Paylevo" },
  { value: "PayoStar", label: "PayoStar" },
  { value: "PayPal", label: "PayPal" },
  { value: "Paysafecard", label: "Paysafecard" },
  { value: "PaySec", label: "PaySec" },
  { value: "PayU", label: "PayU" },
  { value: "PayVision", label: "PayVision" },
  { value: "Pelepare", label: "Pelepare" },
  { value: "Perfect Money", label: "Perfect Money" },
  { value: "Person to Person", label: "Person to Person" },
  { value: "PingitPay", label: "PingitPay" },
  { value: "POLi", label: "POLi" },
  { value: "Portmanat", label: "Portmanat" },
  { value: "Postepay", label: "Postepay" },
  { value: "Prepaid card", label: "Prepaid card" },
  { value: "Puplepay", label: "Puplepay" },
  { value: "Purple Pay", label: "Purple Pay" },
  { value: "PurplePay", label: "PurplePay" },
  { value: "QIWI", label: "QIWI" },
  { value: "QQ-walet", label: "QQ-walet" },
  { value: "QuickPay", label: "QuickPay" },
  { value: "Rapid Transfer", label: "Rapid Transfer" },
  { value: "Rapipago", label: "Rapipago" },
  { value: "Ripple", label: "Ripple" },
  { value: "RunPay", label: "RunPay" },
  { value: "Russian Post", label: "Russian Post" },
  { value: "SafetyPay", label: "SafetyPay" },
  { value: "SampoPankki", label: "SampoPankki" },
  { value: "Santander", label: "Santander" },
  { value: "Sberbank Online", label: "Sberbank Online" },
  { value: "Scotiabank", label: "Scotiabank" },
  { value: "SEB Pank", label: "SEB Pank" },
  { value: "ServiPag", label: "ServiPag" },
  { value: "Siru Mobile", label: "Siru Mobile" },
  { value: "Skrill", label: "Skrill" },
  { value: "Skrill Rapid Transfer", label: "Skrill Rapid Transfer" },
  { value: "Skrill1-Tap", label: "Skrill1-Tap" },
  { value: "SnapScan", label: "SnapScan" },
  { value: "Sofort Banking", label: "Sofort Banking" },
  { value: "Sofortuberweisung", label: "Sofortuberweisung" },
  { value: "Solo Payment System", label: "Solo Payment System" },
  { value: "Sparbanken", label: "Sparbanken" },
  { value: "Speedcard", label: "Speedcard" },
  { value: "SporoPay", label: "SporoPay" },
  { value: "Steam", label: "Steam" },
  { value: "Sticpay", label: "Sticpay" },
  { value: "Suomen Verkkomaksut", label: "Suomen Verkkomaksut" },
  { value: "Swedbank", label: "Swedbank" },
  { value: "TDB Pay", label: "TDB Pay" },
  { value: "Tele2", label: "Tele2" },
  { value: "Telepay", label: "Telepay" },
  { value: "Tether (USDT)", label: "Tether (USDT)" },
  { value: "Ticket Surf", label: "Ticket Surf" },
  { value: "Todito Cash", label: "Todito Cash" },
  { value: "Trustly", label: "Trustly" },
  { value: "TrustPay", label: "TrustPay" },
  { value: "U.mob", label: "U.mob" },
  { value: "Ukash", label: "Ukash" },
  { value: "UnionPay", label: "UnionPay" },
  { value: "UPayCard", label: "UPayCard" },
  { value: "UseMyBank", label: "UseMyBank" },
  { value: "UseMyFunds", label: "UseMyFunds" },
  { value: "UseMyServices", label: "UseMyServices" },
  { value: "Uzcard", label: "Uzcard" },
  { value: "VCC", label: "VCC" },
  { value: "Venus Point", label: "Venus Point" },
  { value: "Virtual Card", label: "Virtual Card" },
  { value: "Visa", label: "Visa" },
  { value: "Visa Debit", label: "Visa Debit" },
  { value: "Visa Electron", label: "Visa Electron" },
  { value: "Vodacon Tanzania", label: "Vodacon Tanzania" },
  { value: "WebMoney", label: "WebMoney" },
  { value: "Wide UP", label: "Wide UP" },
  { value: "WireCard", label: "WireCard" },
  { value: "Yandex.Money", label: "Yandex.Money" },
  { value: "Zain Cash", label: "Zain Cash" },
  { value: "Zimpler", label: "Zimpler" },
  { value: "ZotaPay", label: "ZotaPay" },
];

export const LANGUAGES = [
  { value: "African", label: "African" },
  { value: "Afrikaans", label: "Afrikaans" },
  { value: "Albanian", label: "Albanian" },
  { value: "American English", label: "American English" },
  { value: "Arabic", label: "Arabic" },
  { value: "Argentinian Spanish", label: "Argentinian Spanish" },
  { value: "Armenian", label: "Armenian" },
  { value: "Australian English", label: "Australian English" },
  { value: "Azerbaijani", label: "Azerbaijani" },
  { value: "Belarusian", label: "Belarusian" },
  { value: "Bosnian", label: "Bosnian" },
  { value: "Brazilian Portuguese", label: "Brazilian Portuguese" },
  { value: "British English", label: "British English" },
  { value: "Bulgarian", label: "Bulgarian" },
  { value: "Canadian English", label: "Canadian English" },
  { value: "Canadian French", label: "Canadian French" },
  { value: "Chilean Spanish", label: "Chilean Spanish" },
  { value: "Chinese", label: "Chinese" },
  { value: "Croatian", label: "Croatian" },
  { value: "Czech", label: "Czech" },
  { value: "Danish", label: "Danish" },
  { value: "Dutch", label: "Dutch" },
  { value: "English", label: "English" },
  { value: "Estonian", label: "Estonian" },
  { value: "Finnish", label: "Finnish" },
  { value: "French", label: "French" },
  { value: "Georgian", label: "Georgian" },
  { value: "German", label: "German" },
  { value: "Greek", label: "Greek" },
  { value: "Hebrew", label: "Hebrew" },
  { value: "Hindi", label: "Hindi" },
  { value: "Hungarian", label: "Hungarian" },
  { value: "Icelandic", label: "Icelandic" },
  { value: "Indonesian", label: "Indonesian" },
  { value: "Irish English", label: "Irish English" },
  { value: "Italian", label: "Italian" },
  { value: "Japanese", label: "Japanese" },
  { value: "Kazakh", label: "Kazakh" },
  { value: "Khmer", label: "Khmer" },
  { value: "Korean", label: "Korean" },
  { value: "Latvian", label: "Latvian" },
  { value: "Lithuanian", label: "Lithuanian" },
  { value: "Macedonian", label: "Macedonian" },
  { value: "Malay", label: "Malay" },
  { value: "Maltese", label: "Maltese" },
  { value: "Mexican Spanish", label: "Mexican Spanish" },
  { value: "Mongolian", label: "Mongolian" },
  { value: "New Zealander English", label: "New Zealander English" },
  { value: "Norwegian", label: "Norwegian" },
  { value: "Persian", label: "Persian" },
  { value: "Polish", label: "Polish" },
  { value: "Portuguese", label: "Portuguese" },
  { value: "Romanian", label: "Romanian" },
  { value: "Russian", label: "Russian" },
  { value: "Serbian", label: "Serbian" },
  { value: "Slovak", label: "Slovak" },
  { value: "Slovenian", label: "Slovenian" },
  { value: "South African", label: "South African" },
  { value: "South African English", label: "South African English" },
  { value: "Spanish", label: "Spanish" },
  { value: "Swedish", label: "Swedish" },
  { value: "Thai", label: "Thai" },
  { value: "Turkish", label: "Turkish" },
  { value: "Ukrainian", label: "Ukrainian" },
  { value: "Urdu", label: "Urdu" },
  { value: "Uzbek", label: "Uzbek" },
  { value: "Vietnamese", label: "Vietnamese" },
];

export const CASINO_BONUS_TYPES = [
  { value: "Cashback Bonus", label: "Cashback Bonus" },
  { value: "Daily Reload Bonus", label: "Daily Reload Bonus" },
  { value: "Deposit Bonus", label: "Deposit Bonus" },
  { value: "Free Play/Bet Bonus", label: "Free Play/Bet Bonus" },
  { value: "Free Spins Bonus", label: "Free Spins Bonus" },
  { value: "Loyalty Bonus", label: "Loyalty Bonus" },
  { value: "Mobile Bonus", label: "Mobile Bonus" },
  { value: "No Deposit Bonus", label: "No Deposit Bonus" },
  { value: "Progressive Jackpots Bonus", label: "Progressive Jackpots Bonus" },
  { value: "Referral Bonus", label: "Referral Bonus" },
  { value: "Reload Bonus", label: "Reload Bonus" },
  { value: "Slot Races", label: "Slot Races" },
  { value: "Slots Bonuses", label: "Slots Bonuses" },
  { value: "Special Bonus", label: "Special Bonus" },
  { value: "VIP/Highroller Bonus", label: "VIP/Highroller Bonus" },
  { value: "Weekly Bonuses", label: "Weekly Bonuses" },
  { value: "Welcome Bonus", label: "Welcome Bonus" },
];

export const CUSTOMER_SUPPORT = [
  {
    value: "Email",
    label: "Email",
  },
  {
    value: "Live Chat",
    label: "Live Chat",
  },
  {
    value: "Telephone",
    label: "Telephone",
  },
];
